import React from "react";
import MpTextField from "../../../../../components/MpTextField";
import { useTranslation } from "../../../../../hooks";

interface IProps {
  value: string;
  label?: string;
}

const WalletAddressDisplayOnlyField = (props: IProps) => {
  const { value, label } = props;

  const { t } = useTranslation("tronWalletResourceBalance");

  return (
    <>
      <MpTextField
        value={value}
        onChange={() => {}}
        label={label || ""}
        disabled={true}
      />
    </>
  );
};

export default WalletAddressDisplayOnlyField;
